module.exports = {
    data() {
        return {};
    },
    methods: {
        isIE() {
            return navigator.appName === 'Microsoft Internet Explorer'
                || !!(navigator.userAgent.match(/Trident/)
                    || navigator.userAgent.match(/rv:11/));
        },
    },
};
